module.exports = __webpack_public_path__ + "static/media/cleaners.ce59923c.webp";